import { images } from './assets/constants';

// Function to return a random item from an array
export const random_item = (items) => {
    // Use Math.random() to generate a random number between 0 and 1,
    // multiply it by the length of the array, and use Math.floor() to round down to the nearest integer
    return items[Math.floor(Math.random() * items.length)];
}

export const getKeyByValue = (obj, value) => {
    return Object.keys(obj).find(key => obj[key] === value);
};

export const prettifyStaticPhone = (rawPhone) => {
    let workingPhone = rawPhone.split('');

    workingPhone.splice(0, 0, "(")
    workingPhone.splice(4, 0, ") ")
    workingPhone.splice(8, 0, "-")

    phonePrettified = workingPhone.join('')

    return phonePrettified
}

// Currency is always USD (a NYC driver pays USD in either language); only the
// number/symbol FORMATTING locale changes. Default 'en' preserves the exact
// prior en-US output for every existing caller — pass the active locale
// (useLocale()/getLocale()) on the /es render path.
const currencyLocale = (locale) => (locale === 'es' ? 'es-US' : 'en-US')

export const makeIntoDollars = (cents, locale = 'en') => {
    const dollars = (cents / 100).toLocaleString(currencyLocale(locale), { style: "currency", currency: "USD" });

    return dollars
}

export const roundedDollars = (cents, locale = 'en') => {
    const roundedDollars = Math.round(cents / 100);

    return roundedDollars.toLocaleString(currencyLocale(locale), {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
}

export const getCardNetworkImg = (cardNetwork) => {

    switch (cardNetwork) {

        case "visa":
            return images.visa
            break;

        case "mastercard":

            return images.mastercard
            break;

        case "amex":

            return images.amex
            break;

        case "discover":

            return images.discover
            break;

        default:
            return null
            break;

    }

}

